module.exports = __webpack_public_path__ + "static/img/mini-exp.87d58a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/mini-exp.png
// module id = i55X
// module chunks = 0